import { errorTypes } from '~/components';

export const config = {
  selectAppointmentTypeNotFound: errorTypes.APPOINTMENT_TYPE_NOT_FOUND,
};
